var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBicibox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#fff}")), /*#__PURE__*/React.createElement("path", {
    d: "M54.7 29.8c0 4.9-1.5 9.8-4.2 13.9s-6.7 7.3-11.2 9.2c-4.6 1.9-9.6 2.4-14.4 1.4s-9.3-3.3-12.8-6.8-5.9-8-6.8-12.8c-1-4.8-.5-9.9 1.4-14.4 1.9-4.6 5.1-8.5 9.2-11.2s8.9-4.2 13.9-4.2c6.6 0 13 2.6 17.7 7.3 4.6 4.6 7.2 11 7.2 17.6z",
    style: {
      fill: "#008ace"
    },
    id: "Calque_1"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46 32.8V32.2c-.3-3.9-1.9-7.5-4.7-10.3-3.1-3.1-7.1-4.8-11.5-4.8-4.3 0-8.4 1.7-11.5 4.8-2.7 2.8-4.4 6.4-4.7 10.3V38c0 .3.3.6.6.6h31.2c.3 0 .6-.3.6-.6v-5.2zm-1.3 4.5H14.8V33c0-.4 0-.8.1-1.3.9-7.5 7.2-13.4 14.8-13.4s14 5.9 14.8 13.4c0 .4.1.8.1 1.3v4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.6 26.8c-.8 0-1.5.2-2.1.5l-1.6-2.5.9-1.9h1c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-3.5c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h1.1l-1.9 4-6-2h-.2l1-2.1s.3-.4 1.4-.4c.3 0 .6-.3.6-.6s-.3-.6-.6-.6c-2 0-2.5 1-2.6 1.1l-2.2 4.8c-.5-.1-.9-.2-1.4-.2-2.7 0-4.9 2.2-4.9 4.9s2.2 4.9 4.9 4.9 4.9-2.2 4.9-4.9c0-1.7-.9-3.2-2.3-4.1l.6-1.3 3.4 4.3c-.2.3-.4.7-.4 1.2 0 .9.6 1.6 1.3 1.9v1c-.3 0-.6.3-.6.6s.3.6.6.6h1.1c.3 0 .6-.3.6-.6s-.3-.6-.6-.6v-1c.6-.2 1.1-.7 1.3-1.3h1.3c.3 2.4 2.3 4.3 4.8 4.3 2.7 0 4.9-2.2 4.9-4.9 0-2.9-2.1-5.1-4.8-5.1zm-12.5 4.9c0 2-1.6 3.6-3.6 3.6s-3.6-1.6-3.6-3.6 1.6-3.6 3.6-3.6c.3 0 .6 0 .9.1l-1.5 3.2c-.1.3 0 .7.3.8.1 0 .2.1.3.1.2 0 .5-.1.6-.4l1.5-3.2c.9.7 1.5 1.8 1.5 3zm9.3-3.7c-.9.7-1.4 1.8-1.6 3h-1.3c-.1-.2-.2-.4-.3-.5l2.1-4.3 1.1 1.8zm.7 1.1 1.2 1.9H34c.2-.7.6-1.4 1.1-1.9zm-5 .7c-.2 0-.3-.1-.5-.1s-.4 0-.5.1l-2.5-3.1 4.3 1.5-.8 1.6zm-.5 2.6c-.4 0-.7-.3-.7-.7 0-.2.1-.4.2-.5.1 0 .1-.1.2-.1l.1-.1c.1 0 .2-.1.3-.1.4 0 .7.3.7.7-.1.5-.4.8-.8.8zm8 2.9c-1.8 0-3.3-1.3-3.6-3h3.4c.2 0 .4-.1.6-.3.1-.2.1-.4 0-.6l-1.9-2.9c.4-.2.9-.3 1.5-.3 2 0 3.6 1.6 3.6 3.6s-1.6 3.5-3.6 3.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicibox);
export default __webpack_public_path__ + "static/media/bicibox.a52e792eb369524aa4320fe3bd9a2362.svg";
export { ForwardRef as ReactComponent };